<template>
  
  <!-- Toast component -->
  <ToastWrapper />

  <!-- Dinamic Dialog component -->
  <DynamicDialogWrapper />

  <!-- API Credentials Setup -->
  <ApiCredentialsSetup 
    v-model:visible="showApiSetup"
    @complete="handleApiSetupComplete"
  />

  <!-- Main component -->
  <RouterView />

</template>

<script setup>

  // based imports
  import { onMounted, computed, ref, watch, inject } from 'vue';
  import { useRouter, useRoute } from 'vue-router';

  // services imports
  import { useDark } from '@vueuse/core';

  // import Toast component
  import ToastWrapper from '@/components/reusable/ToastWrapper.vue';

  // import Dinamic Dialog component
  import DynamicDialogWrapper from '@/components/reusable/DinamicDialogWrapper.vue';

  // import API Credentials Setup
  import ApiCredentialsSetup from '@/components/modals/ApiCredentialsSetup.vue';

  // stores
  import { useAuthStore } from '@/stores/auth';
  import { useApiCredentialsStore } from '@/stores/apiCredentials';
  import { useSetupCredentialsStore } from '@/stores/setupCredentials';

  const router = useRouter();
  const route = useRoute();
  const isLoggedIn = computed(() => useAuthStore().getAuthStatus);
  const apiCredentialsStore = useApiCredentialsStore();
  const setupCredentialsStore = useSetupCredentialsStore();
  const showApiSetup = ref(false);
  const HttpService = inject('HttpService');

  const isLoginRoute = computed(() => route.name === 'login');

  onMounted(async () => {
    useDark();
    
    // Se l'utente è loggato ma non ha credenziali e il setup non è completato
    // generiamo automaticamente le credenziali admin senza mostrare il modale
    if (isLoggedIn.value && 
        !apiCredentialsStore.hasCredentials && 
        !setupCredentialsStore.setupCompleted) {
      
      try {
        // Generiamo automaticamente le credenziali admin
        const success = await setupCredentialsStore.autoGenerateAdminCredentials(HttpService, apiCredentialsStore);
        
        // Se la generazione fallisce, mostriamo il modale di setup
        if (!success) {
          showApiSetup.value = true;
        }
      } catch (error) {
        console.error('Errore nel setup automatico delle credenziali:', error);
        showApiSetup.value = true;
      }
    }
  });

  const handleApiSetupComplete = (credentials) => {
    apiCredentialsStore.setCredentials(credentials);
    setupCredentialsStore.completeSetup();
    showApiSetup.value = false;
  };

  // Modifichiamo il watch per non mostrare il modale automaticamente
  watch(
    [
        () => isLoggedIn.value,
        () => setupCredentialsStore.setupInProgress,
        () => setupCredentialsStore.setupCompleted,
        () => apiCredentialsStore.hasCredentials
    ],
    ([isLogged, inProgress, completed, hasCredentials]) => {
        // Nascondiamo il modale se:
        // - L'utente non è loggato
        // - L'utente ha già credenziali
        // - Il setup è stato completato
        if (!isLogged || hasCredentials || completed) {
            showApiSetup.value = false;
        }
        // Non mostriamo più automaticamente il modale
    },
    { immediate: true }
  );

</script>